import Breadcrumb from "components/commons/bread/Breadcrumb";
import React from "react";
import { useAppDispatch, useAppSelector } from "utils/store";
import { strings } from "../../../intl/fa";
import {
  TutorialPages,
  TutorialsActions,
} from "core/tutorials/tutorials.slice";

const labels: Record<TutorialPages, string> = {
  [TutorialPages.AllTutorials]: strings.tutorials.breadcrumb.all,
  [TutorialPages.TutorialArticles]: strings.tutorials.breadcrumb.articles,
  [TutorialPages.TutorialVideos]: strings.tutorials.breadcrumb.videos,
};

const TutorialsBreadcrumb: React.FC<React.PropsWithChildren<unknown>> = () => {
  const tutorialPage = useAppSelector((state) => state.tutorials.page);
  const history = useAppSelector((state) => state.tutorials.history);
  const currentIndex = history.findIndex((page) => page === tutorialPage);
  const dispatch = useAppDispatch();
  const hide =
    [TutorialPages.AllTutorials].includes(tutorialPage) || currentIndex === 0;

  const onClick = (item: TutorialPages) => {
    const itemIndex = history.findIndex((page) => page === item);
    const newHistory = history.slice(0, itemIndex + 1);
    console.log(newHistory);

    dispatch(TutorialsActions.changeBreadcrumb(newHistory));
  };
  if (hide) return null;

  return (
    <Breadcrumb
      data={history.slice(0, currentIndex + 1).map((page, index) => {
        return {
          isActive: tutorialPage === page,
          label: labels[page],
          onClick: () => {
            if (tutorialPage !== page) {
              onClick(page);
            }
          },
        };
      })}
    />
  );
};

export default TutorialsBreadcrumb;
